import { SUPPORTED_COUNTRY_CODE } from '@store';

export namespace Currency {
  export enum Currency {
    CZK = 'CZK',
    DKK = 'DKK',
    EUR = 'EUR',
    GBP = 'GBP',
    NOK = 'NOK',
    PLN = 'PLN',
    RON = 'RON',
    SEK = 'SEK',
    TRY = 'TRY',
    BGN = 'BGN',
    HUF = 'HUF',
    RUB = 'RUB',
    UAH = 'UAH',
    RSD = 'RSD',
  }

  export function getCurrencyBasingOnVkorg(country: string): Currency {
    if (!country) {
      return;
    }

    let matchingCountry: string;

    const supportedCountryCodeValues = Object.values(SUPPORTED_COUNTRY_CODE);
    if (country.includes('-')) {
      // Find 'de-DE' when 'de' is passed
      matchingCountry = supportedCountryCodeValues.find(
        (val) => val.toLowerCase() === country.toLowerCase()
      );
    } else {
      matchingCountry = supportedCountryCodeValues.find(
        (val) => val.split('-')[0].toLowerCase() === country.toLowerCase()
      );
    }

    if (!matchingCountry) {
      return;
    }

    switch (matchingCountry) {
      case SUPPORTED_COUNTRY_CODE.DE:
      case SUPPORTED_COUNTRY_CODE.AT:
      case SUPPORTED_COUNTRY_CODE.ES:
      case SUPPORTED_COUNTRY_CODE.ET:
      case SUPPORTED_COUNTRY_CODE.FI:
      case SUPPORTED_COUNTRY_CODE.FR:
      case SUPPORTED_COUNTRY_CODE.IT:
      case SUPPORTED_COUNTRY_CODE.LV:
      case SUPPORTED_COUNTRY_CODE.NL:
      case SUPPORTED_COUNTRY_CODE.PT:
      case SUPPORTED_COUNTRY_CODE.SL:
      case SUPPORTED_COUNTRY_CODE.HR:
      case SUPPORTED_COUNTRY_CODE.LT:
      case SUPPORTED_COUNTRY_CODE.BE:
        return Currency.EUR;

      case SUPPORTED_COUNTRY_CODE.CS:
        return Currency.CZK;

      case SUPPORTED_COUNTRY_CODE.DA:
        return Currency.DKK;

      case SUPPORTED_COUNTRY_CODE.EN:
        return Currency.GBP;

      case SUPPORTED_COUNTRY_CODE.NO:
        return Currency.NOK;

      case SUPPORTED_COUNTRY_CODE.PL:
        return Currency.PLN;

      case SUPPORTED_COUNTRY_CODE.RO:
        return Currency.RON;

      case SUPPORTED_COUNTRY_CODE.SV:
        return Currency.SEK;

      case SUPPORTED_COUNTRY_CODE.TR:
        return Currency.TRY;

      case SUPPORTED_COUNTRY_CODE.BG:
        return Currency.BGN;

      case SUPPORTED_COUNTRY_CODE.HU:
        return Currency.HUF;

      case SUPPORTED_COUNTRY_CODE.RU:
        return Currency.RUB;

      case SUPPORTED_COUNTRY_CODE.UK:
        return Currency.UAH;

      case SUPPORTED_COUNTRY_CODE.SR:
        return Currency.RSD;
    }
  }
}
